export enum AdminsActions {
    SET_ADMIN = "setAdmin",
    SET_SELECTED_ADMIN = "setSelectedAdmin",
    TOGGLE_ADMINS_PANEL = "toggleAdminsPanel",
    RELOAD_ADMINS = "reloadAdmins",
    CLEAR= "clearAdmins",
    ADD_ADMIN="addAdmin"
  }